<template>
  <div class="checkout-behind-curtains">
    <div class="checkout-behind-curtains__container container-checkout">
      <div class="checkout-behind-curtains__title">
        "Behind The Curtains" <br />
        <b>How Does It Actually Work</b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckoutBehindCurtains',
}
</script>

<style lang="scss">
.checkout-behind-curtains {
  &__title {
    padding: 48px 40px;
    text-align: center;
    font-weight: 400;
    font-size: 36px;
    line-height: 49px;
    background-color: var(--color-white-01);
    border-radius: 12px;

    b {
      font-weight: 800;
    }
  }
}
</style>
